var $$ = $$ || {};

$$.ScrollBottomRegistration = class ScrollBottomRegistration {
    constructor (root, options = {}) {
        var defaultOptions = {};

        this.root = root;
        this.options = _.assign(defaultOptions, options);

        this.formOffset = 0;

        this._cacheNodes();
        this._bindEvents();
        this._ready();
    }

    _cacheNodes() {
        this.nodes = {
            form: $('.js-registration-event-form'),
            scrollToButton: this.root.find('.js-scroll-bottom')
        };
    }

    _bindEvents() {
        $$.window.on('resize', () => {
            this._resize();
        });

         this.nodes.scrollToButton.on('click', () => {
             $('html, body').animate({ scrollTop: this.formOffset
             }, 400);
          });
    }

    _ready() {
        this._resize();
    }

    _resize() {
        this.formOffset = this.nodes.form.offset().top - $$.windowHeight / 3;
    }
}